export enum WavePattern {
  MANUAL = 'MANUAL',
  SINGLE_DROP = 'SINGLE_DROP',
  DOUBLE_SLIT = 'DOUBLE_SLIT',
  CONCENTRIC = 'CONCENTRIC',
  CHAOS = 'CHAOS',
  PRESET = 'PRESET',
  AI_GENERATED = 'AI_GENERATED',
}

export interface SimulationConfig {
  damping: number;
  frequency: number; // Simulation oscillation speed
  baseFrequency?: number; // Carrier/base frequency for audio/export (defaults to frequency)
  amplitude: number;
  pattern: WavePattern;
  autoPlay: boolean;
  rainMode: boolean;
  loop: boolean;
}

export interface Emitter {
  x: number; // 0-1 coordinate
  y: number; // 0-1 coordinate
  frequency: number; // Hz
  phase: number;
  active: boolean;
}

export interface Point {
  x: number;
  y: number;
}

export interface AIWaveResponse {
  name: string;
  description: string;
  config: Partial<SimulationConfig>;
  emitters: Emitter[];
  focusPoints?: Point[]; // New: Points to target with phased array
}
